import React, { Component, Fragment } from 'react';

import {
	Pane, Dialog, toaster,
} from 'evergreen-ui';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import ListTable from '../../../components/ListTable';

import { ContentTitle } from '../../../components/utilities/styledComponents/ContentTitle';
import { StyledUsersList } from './style/styledUsersList';
import { StyledButton } from '../../../components/utilities/styledComponents/StyledButton';
import { LoaderFull } from '../../../components/Loader';

export default class UserList extends Component {
	constructor(props) {
		super(props);

		this.getData = this.getData.bind(this);
		this.changeSorting = this.changeSorting.bind(this);

		this.state = {
			valueSearchUser: '',
			elementsList: false,
			sort: 'asc',
			url: '/users',
			isShown: false,
			itemListId: 0,
			feeback: '',
		};

		this.elementsData = {
			keys: [
				{
					col: 'name', title: 'Usuário', sort: true, id: 'user',
				},
				{
					col: 'email', title: 'E-mail', sort: true, id: 'email',
				},
			],
			actions: [
				{ action: 'edit', name: 'Editar Usuário', link: '/backoffice/usuarios' },
				{ action: 'delete', name: <i className="fa fa-trash" aria-hidden="true" /> },
			],
		};
	}

	componentDidMount() {
		const { location } = this.props;

		if (location.state) {
			toaster.success(
				location.state.formMessage,
			);
		}
	}

	searchUsersList = () => {
		const { valueSearchUser, url } = this.state;

		api.get(`${url}?query=${valueSearchUser}`)
			.then(response => this.setState({
				elementsList: this.buildObjectData(response.data.data),
			}));
	};

	removeUserList = id => this.setState({ isShown: true, itemListId: id });

	confirmRemoveUserList = () => {
		const { elementsList, itemListId, url } = this.state;

		const filterElementsList = elementsList.filter(item => item.id !== itemListId);

		api.delete(`${url}/${itemListId}`)
			.then(() => {
				toaster.success(
					'Usuário deletado com sucesso!',
				);

				return this.setState({
					elementsList: filterElementsList,
				});
			})
			.catch((error) => {
				if (error.response.status === 403) {
					return toaster.danger(
						'Ação não autorizada!',
					);
				}

				if (error.response.status === 404) {
					return toaster.danger(
						'Usuário não encontrado!',
					);
				}

				return toaster.danger(
					'Ops! Ocorreu um erro, tente novamente mais tarde.',
				);
			});

		this.setState({ isShown: false });
	};

	getData = (url) => {
		api.get(url)
			.then(response => this.setState({
				elementsList: this.buildObjectData(response.data.data),
			}))
			.catch(() => toaster.danger(
					'Ops! Ocorreu um erro, tente novamente mais tarde.',
				));
	};

	changeSorting = (column, sort) => {
		const { url } = this.state;

		sort = (sort === 'asc') ? 'desc' : 'asc';

		this.setState({
			sort,
		});

		this.getData(`${url}?column=${column}&sort=${sort}`);
	};

	buildObjectData = values => values.map(data => (
			{ id: data.id, name: data.attributes.name, email: data.attributes.email }
		));

	buildObjectPagination = data => ({
		id: data.id,
		meta: data.attributes,
	});

	render() {
		const {
			elementsList, url, sort, isShown, feeback, valueSearchUser,
		} = this.state;

		if (!elementsList) {
			this.getData(url);

			return (
				<LoaderFull />
			);
		}

		return (
			<Fragment>
				<Pane>
					<Dialog
						isShown={isShown}
						intent="danger"
						title="Tem certeza que deseja excluir esse usuário?"
						onCloseComplete={() => this.setState({ isShown: false })}
						onConfirm={() => this.confirmRemoveUserList(() => {})}
						confirmLabel="Excluir usuário"
					>
						O usuário não poderá mais acessar a plataforma, mas seu histórico será mantido.
					</Dialog>
				</Pane>

				<ContentTitle className="d-flex justify-content-between">
					Listagem de usuários
					<StyledButton>
						<Link to="/backoffice/usuarios/cadastro" className="btn btn-register-user">Cadastrar um novo usuário</Link>
					</StyledButton>
				</ContentTitle>

				{ feeback }

				<StyledUsersList>
					<header>
						<i className="fa fa-bullhorn" />
						<strong>Usuários</strong>
					</header>

					<form>
						<label htmlFor="searchUser">Buscar:</label>
						<input id="searchUser" className="d-block w-100" value={valueSearchUser} onChange={(e) => { this.setState({ valueSearchUser: e.target.value }, this.searchUsersList); }} />
					</form>

					<ListTable
						keys={this.elementsData.keys}
						actions={this.elementsData.actions}
						funcDelete={this.removeUserList}
						elements={elementsList}
						changeSorting={this.changeSorting}
						sort={sort}
					/>
				</StyledUsersList>
			</Fragment>
		);
	}
}
